(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-part-key', {
            parent: 'entity',
            url: '/public-site-part-key?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-keys.html',
                    controller: 'PublicSitePartKeyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-part-key-detail', {
            parent: 'entity',
            url: '/public-site-part-key/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartKey.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-detail.html',
                    controller: 'PublicSitePartKeyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSitePartKey', function($stateParams, PublicSitePartKey) {
                    return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-part-key',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-part-key-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-dialog.html',
                    controller: 'PublicSitePartKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartKey', function(PublicSitePartKey) {
                            return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-key.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-dialog.html',
                    controller: 'PublicSitePartKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                translationKey: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-part-key', null, { reload: 'public-site-part-key' });
                }, function() {
                    $state.go('public-site-part-key');
                });
            }]
        })
        .state('public-site-part-key.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-dialog.html',
                    controller: 'PublicSitePartKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartKey', function(PublicSitePartKey) {
                            return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-key', null, { reload: 'public-site-part-key' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-key.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-delete-dialog.html',
                    controller: 'PublicSitePartKeyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSitePartKey', function(PublicSitePartKey) {
                            return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-key', null, { reload: 'public-site-part-key' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
